"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTable = exports.isGeneralAdmission = exports.isSeat = exports.isBooth = void 0;
// Runtime type helper functions
function isBooth(object) {
  return object.objectType === 'Booth';
}
exports.isBooth = isBooth;
function isSeat(object) {
  return object.objectType === 'Seat';
}
exports.isSeat = isSeat;
function isGeneralAdmission(object) {
  return object.objectType === 'GeneralAdmissionArea';
}
exports.isGeneralAdmission = isGeneralAdmission;
function isTable(object) {
  return object.objectType === 'Table';
}
exports.isTable = isTable;